import "./HrPeople.scss";
import React, { useEffect, useRef, useState } from "react";
import CircularButton, { CustomButtonMenu, CustomLoadingButton } from "../../../components/ui/CustomButton.jsx";
import app from "../../../utils/firebase.js";
import newRequest from "../../../utils/newRequest.js";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { FiSearch } from "react-icons/fi";
import RefreshIcon from "@mui/icons-material/Refresh";
import { FaPeopleRoof } from "react-icons/fa6";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  TablePagination,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import { motion } from "framer-motion";
import VideoPlayer from "../../../components/videoPlayer/VideoPlayer.jsx";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy.jsx";
import { useTranslation } from "react-i18next";
import { MdArrowBackIos, MdClose, MdEmail, MdOutlineNumbers, MdPhone } from "react-icons/md";
import { CiImageOn } from "react-icons/ci";
import PageviewOutlinedIcon from '@mui/icons-material/PageviewOutlined';
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { fetchClientsBySearch, getCssValue, logData } from "../../../utils/genericFunctions.js";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import { IoDocumentTextSharp } from "react-icons/io5";
import { IoIosPeople } from "react-icons/io";


const HrPeople = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [peopleExists, setPeopleExists] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const [people, setPeople] = useState([]);
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const closeBtnRef = useRef(null);
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const showBack = location.state?.showBack || "N";
  const favMenu = location.state?.favMenu || "N";
  const menuDocid = location.state?.menuDocid || undefined;
  const menuFilter = location.state?.menuFilter;

  const [selectedMenu, setSelectedMenu] = useState(null);
  const [video, setVideo] = useState(undefined);
  const [videoPerc, setVideoPerc] = useState(0);
  const [inputs, setInputs] = useState({});

  const [definedSectors, setDefinedSectors] = useState([]);
  const [definedSubSectors, setDefinedSubSectors] = useState([]);
  const [entityCatgOptions, setPersonCatgOptions] = useState([]);
  const [entityTypeOptions, setPersonTypeOptions] = useState([]);
  const [entityStatusOptions, setPersonStatusOptions] = useState([]);

  const [filterEntStatus, setFilterEntStatus] = useState(null);
  const [filterEntType, setFilterEntType] = useState(null);
  const [filterEntCategory, setFilterEntCategory] = useState(null);
  const [filterEntSector, setFilterEntSector] = useState(null);
  const [filterEntSubSector, setFilterEntSubSector] = useState(null);
  const [filterEntCode, setFilterEntCode] = useState("");
  const [filterPerson, setFilterPerson] = useState(null);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [disableOtherFields, setDisableOtherFields] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTermPerson, setSearchTermPerson] = useState("");
  const [entityPage, setPersonPage] = useState(0);

  const handlePersonChangePage = (event, newPage) => {
    setPersonPage(newPage);
  };

  const handlePersonRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setPersonPage(0);
  };

  const filteredPersonData = people.filter(
    (item) =>
      item?.ent_code?.toLowerCase().includes(searchTermPerson?.toLowerCase()) ||
      item?.ent_name?.toLowerCase().includes(searchTermPerson?.toLowerCase()) ||
      item?.ent_email?.toLowerCase().includes(searchTermPerson?.toLowerCase()) ||
      item.ent_phone_no?.toLowerCase().includes(searchTermPerson?.toLowerCase())
  );
  const slicedPersonData = filteredPersonData.slice(
    entityPage * rowsPerPage,
    entityPage * rowsPerPage + rowsPerPage
  );
  // end of list data

  const uploadFile = (file, urlType) => {
    const storage = getStorage(app);
    const fileName = new Date().getTime() + file.name;
    const storageRef = ref(storage, "Videos/" + fileName);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setVideoPerc(Math.round(progress));
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
          default:
            break;
        }
      },
      (error) => { },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setInputs((prev) => {
            return { ...prev, [urlType]: downloadURL };
          });
        });
      }
    );
  };

  const fetchPeople = async () => {
    try {
      const res = await newRequest.post(
        "/hrPeople/findAll",
        {
          ent_aent_code: "",
          result_limit: 3
        }
      );
      if (res.data?.length > 0) {
        setPeopleExists(true)
      }
      setPeople(res.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const fetchPersonType = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll",
        {
          sys_org_code: currentUser.usr_org_code,
          sys_type: "Person Types",
        }
      );

      const options = res.data?.map((entityType) => ({
        value: entityType?.sys_code,
        label: entityType?.sys_name,
      }));

      setPersonTypeOptions(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };


  const fetchPersonCatg = async () => {
    try {
      const res = await newRequest.get("/allPersonCatg/findAll");
      const options = res.data?.map((entityCatg) => ({
        aent_layouts: entityCatg?.aent_layouts,
        value: entityCatg?.aent_code,
        label: entityCatg?.aent_name,
      }));
      setPersonCatgOptions(options);
    } catch (error) {
      console.error("Error fetching entity category:", error);
    }
  };


  const fetchPersonStatus = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Person Status" });
      const options = res.data?.map((entityStatus) => ({
        value: entityStatus?.sys_code,
        label: entityStatus?.sys_name,
      }));

      setPersonStatusOptions(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };



  const onComponentMount = () => {
    try {
      setIsLoading(true);
      fetchPeople();
      fetchPersonStatus();
      fetchPersonType();
      fetchPersonCatg();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const menus = [
    {
      _id: "cards",
      title: t('cards'),
    },
    {
      _id: "list",
      title: t('list'),
    },
  ]

  const handleSearchPeople = async () => {
    try {
      if (searchTerm) {
        setIsLoading(true);
        const res = await newRequest.post(
          "/hrPeople/search",
          {
            search_input: searchTerm,
            multiple_fields: "Y",
            limit: 20,
          }
        );
        setIsLoading(true);
        setPeople(res.data);
      } else {
        fetchPeople();
      }
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetPeople = async () => {
    try {
      // check at least two fields are selected
      if (!filterEntType && !filterEntCategory && !filterEntSector && !filterEntSubSector
        && !filterPerson && !filterEntCode && !filterEntStatus && !selectedPerson) {
        setIsNotifyDialogOpen(true);
        setNotifyDialogTitle("Error");
        setNotifyDialogText("Please select at least one filter to run the search.");
        return;
      }

      // await new Promise((resolve) => setTimeout(resolve, 5000));
      const res = await newRequest.post("/hrPeople/peopleList", {
        ent_code: filterPerson ? filterPerson?.value : filterEntCode,
        ent_status: !filterEntStatus || filterEntStatus?.value === "All" ? "" : filterEntStatus?.value,
        ent_type: !filterEntType || filterEntType.value === "All" ? "" : filterEntType?.value,
        ent_aent_code: !filterEntCategory || filterEntCategory?.value === "All" ? "" : filterEntCategory?.value,
        ent_sector: !filterEntSector || filterEntSector?.value === "All" ? "" : filterEntSector?.value,
        ent_sub_sector: !filterEntSubSector || filterEntSubSector?.value === "All" ? "" : filterEntSubSector?.value,
      });
      // console.log(`carrierStmt  ${JSON.stringify(res.data, null, 2)}`);
      setPeople(res.data);
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    if (isNotifyDialogOpen && closeBtnRef.current) {
      closeBtnRef.current.focus();
    }
  }, [isNotifyDialogOpen]);

  useEffect(() => {
    video && uploadFile(video, "videoUrl");
  }, [video]);


  useEffect(() => {
    onComponentMount();
    setSelectedMenu(menus[0]);
  }, []);

  return (
    <motion.div
      className="hr-people-home"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="people-main-wrapper">
          <motion.div className="list-wrapper"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}>
            <div className="list-navbar">
              <div className="list-navbar-left">
                <span className="page-title">{t('people').toUpperCase()}</span>
              </div>
              <div className="list-navbar-right">
                <div className="home-menus-wrapper">
                  {menus?.map((row, index) => (
                    <React.Fragment key={row._id}>
                      <span style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                        <CustomButtonMenu
                          className="single-menu"
                          currentButton={selectedMenu?._id === row?._id}
                          currentTheme={currentTheme}
                          onClick={() => setSelectedMenu(row)}
                        >
                          {row?.title}
                        </CustomButtonMenu>
                      </span>
                      {index < menus.length - 1 && <span className="separator-v" />}
                    </React.Fragment>
                  ))}
                </div>
                <span className="separator-v" />
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="left"
                  endIcon={<RefreshIcon />} onClick={fetchPeople}>
                  {t('refresh')}
                </CustomLoadingButton>
                {/* <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="none"
                  endIcon={<CiImport />} 
                   onClick={() => navigate("/entityImport", {  state: { person: "Y" } })}>
                  {t('import')}
                </CustomLoadingButton> */}
                {selectedMenu?._id === "list" && <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="none"
                  endIcon={<IoDocumentTextSharp />}
                  onClick={() => setReportsDialogOpen(true)}>
                  {t('reports')}
                </CustomLoadingButton>}
                <CustomLoadingButton
                  endIcon={<AddIcon />}
                  iconPosition="end"
                  borderRadiusType="right"
                  currentTheme={currentTheme}
                  onClick={() => navigate(`/entity/new`, { state: { person: "Y" } })}
                >
                  {t('newPerson')}
                </CustomLoadingButton>
                {/* This part shows if the menu was opened from home screen */}
                {showBack === "Y" && <hr className="separator-v" />}
                {showBack === "Y" &&
                  <span className="back-icon" onClick={() => navigate(-1)}>
                    <MdArrowBackIos size={24} />
                  </span>
                }
              </div>
            </div>
            {selectedMenu?._id === "cards" &&
              <motion.div className="list-content"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1, transition: { duration: 1 } }}
                exit={{ opacity: 0, transition: { duration: 1 } }}>
                <IoIosPeople className="icon" />
                <span className="title">{t('peopleTitle')}</span>
                <p>{t('peopleTitleDesc')}</p>
                <div className="search-input-wrapper" style={{ width: "50%" }}>
                  <FiSearch className="search-input-icon" />
                  <input
                    className="search-input"
                    type="text"
                    placeholder={`${t('search')} ${t('people')}...`}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter') handleSearchPeople(); }}
                  />
                  {searchTerm?.length > 0 && (
                    <CloseIcon
                      onClick={(e) => {
                        try {
                          fetchPeople();
                          setSearchTerm("");
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      className="search-input-icon"
                    />
                  )}
                  {searchTerm?.length === 0 && (
                    <span className="search-input-icon" />
                  )}
                </div>
                {searchTerm?.length > 0 && people?.length > 0 && <span className="sub-title" style={{ marginTop: "10px" }}>{`fetched ${people?.length} records`}</span>}
                {people?.length > 0 &&
                  <div className="cards-wrapper">
                    {people?.map((row) => (
                      <div className="single-card"
                        key={row?._id}
                        onClick={() => navigate(`/entity/${row?._id}`, { state: { person: "Y" } })}
                      >
                        <div className="single-card-top">
                          <div className="single-card-top-left">
                            {row?.ent_photo_url && <img
                              src={row?.ent_photo_url}
                              alt=""
                              className="img"
                            />}
                            {!row?.ent_photo_url && <CiImageOn style={{ width: "60px", height: "60px" }} />}
                          </div>
                          <div className="single-card-top-right">
                            <span className="user-full-name">{row?.ent_name}</span>
                            <span className="user-type">{`${row?.aent_name_xx}`}</span>
                          </div>
                        </div>
                        <div className="single-card-center">
                          <div className="single-card-center-row">
                            <span className="user-title">{t('type')}</span>
                            <span className="user-title">{t('status')}</span>
                          </div>
                          <div className="single-card-center-row">
                            <span className="user-title-value">{row?.ent_type}</span>
                            <span className="user-title-value">{row?.ent_status}</span>
                            {/* <span className={`status ${row?.ent_status}`}>{row?.ent_status}</span> */}
                          </div>
                          <div className="single-card-center-col">
                            <div className="email-phone-row">
                              <MdOutlineNumbers className="icon" /> <span>{row?.ent_code}</span>
                            </div>
                            <div className="email-phone-row">
                              <MdPhone className="icon" /> <span>{row?.ent_phone_no}</span>
                            </div>
                            <div className="email-phone-row">
                              <MdEmail className="icon" /> <span>{row?.ent_email}</span>
                            </div>
                          </div>
                        </div>
                        <div className="single-card-bottom">
                          <WorkedOnBy name={row?.updated_by_name_xx} photoUrl={row?.updated_by_photo_url_xx} time_ago_xx={row?.time_ago_xx} />
                        </div>
                      </div>
                    ))}
                  </div>}
                <div className="list-footer">
                  <button className="overlay-button" onClick={() => setIsOverlayOpen(true)}>
                    {t('how')}
                  </button>
                </div>
              </motion.div>}
            {selectedMenu?._id === "list" &&
              <motion.div
                className="filter-wrapper"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1, transition: { duration: 1 } }}
                exit={{ opacity: 0, transition: { duration: 1 } }}
              >
                <ExpandableComponent
                  title={""}
                  subtitle={<span className="sub-title" style={{ alignSelf: "center" }}>{t('pleaseEnterSearch')}</span>}
                  defaultExpanded={true}
                >
                  <div className="filter">
                    <div className="left">
                      <div className="input-item-with-label">
                        <label
                          htmlFor="ent_type"
                          className="form-dropdown-label"
                          style={{ width: "100px" }}
                        >
                          {t('type').toUpperCase()}
                        </label>
                        <Select
                          id="ent_type"
                          name="ent_type"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="150px"
                          value={filterEntType}
                          onChange={(selectedOption) => setFilterEntType(selectedOption)}
                          options={entityTypeOptions}
                          isSearchable={true}
                          isClearable
                          placeholder={t('type').toUpperCase()}
                          isDisabled={disableOtherFields}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="category"
                          className="form-dropdown-label"
                          style={{ width: "100px" }}
                        >
                          {t('category').toUpperCase()}
                        </label>
                        <Select
                          id="category"
                          name="category"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="150px"
                          value={filterEntCategory}
                          onChange={(selectedOption) => setFilterEntCategory(selectedOption)}
                          options={entityCatgOptions}
                          isSearchable={true}
                          isClearable
                          placeholder={t('category').toUpperCase()}
                          isDisabled={disableOtherFields}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="filter_ent_code"
                          className="form-dropdown-label"
                          style={{ width: "100px" }}
                        >
                          {t('code').toUpperCase()}
                        </label>
                        <input
                          id="filter_ent_code"
                          name="filter_ent_code"
                          type="text"
                          placeholder={t('code').toUpperCase()}
                          value={filterEntCode}
                          className="form-input-item"
                          style={{ width: "150px" }}
                          onChange={(e) => {
                            try {
                              setFilterEntCode(e.target.value);
                              if (e.target.value) {
                                setDisableOtherFields(true);
                              } else {
                                setDisableOtherFields(false);
                              }
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') handleGetPeople();
                          }}
                        />
                      </div>
                    </div>
                    <div className="center">
                      <div className="input-item-with-label">
                        <label
                          htmlFor="sector"
                          className="form-dropdown-label"
                          style={{ width: "130px" }}
                        >
                          {t('sector').toUpperCase()}
                        </label>
                        <Select
                          id="sector"
                          name="sector"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="350px"
                          value={filterEntSector}
                          onChange={(selectedOption) => {
                            try {
                              setFilterEntSubSector(null);
                              setFilterEntSector(selectedOption);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          options={definedSectors}
                          isSearchable={true}
                          isClearable
                          placeholder={t('sector').toUpperCase()}
                          isDisabled={disableOtherFields}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') handleGetPeople();
                          }}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="subSector"
                          className="form-dropdown-label"
                          style={{ width: "130px" }}
                        >
                          {t('subSector').toUpperCase()}
                        </label>
                        <Select
                          id="subSector"
                          name="subSector"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="350px"
                          value={filterEntSubSector}
                          onChange={(selectedOption) => setFilterEntSubSector(selectedOption)}
                          options={definedSubSectors}
                          isSearchable={true}
                          isClearable
                          placeholder={t('subSector').toUpperCase()}
                          isDisabled={disableOtherFields}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') handleGetPeople();
                          }}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="entity" style={{ width: "130px" }}>
                          {t('entity').toUpperCase()}
                        </label>
                        <AsyncSelect
                          id="entity"
                          name="entity"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="350px"
                          value={filterPerson}
                          onChange={(selectedOption) => setFilterPerson(selectedOption)}
                          loadOptions={fetchClientsBySearch}
                          isSearchable={true}
                          isClearable
                          placeholder={t('entity').toUpperCase()}
                          noOptionsMessage={() => "Type Minimum 2 Letter to Search"}
                          isDisabled={disableOtherFields}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') handleGetPeople();
                          }}
                        />
                      </div>
                    </div>
                    <div className="right">
                      <div className="input-item-with-label">
                        <label htmlFor="status" style={{ width: "100px" }}>
                          {t('status').toUpperCase()}
                        </label>
                        <Select
                          id="status"
                          name="status"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="150px"
                          value={filterEntStatus}
                          onChange={(selectedOption) => setFilterEntStatus(selectedOption)}
                          options={entityStatusOptions}
                          isSearchable={true}
                          isClearable
                          placeholder={t('status').toUpperCase()}
                          isDisabled={disableOtherFields}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') handleGetPeople();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", margin: "5px 0px" }}>
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      endIcon={<PageviewOutlinedIcon />}
                      onClick={handleGetPeople}
                    >
                      {t('run').toUpperCase()}
                    </CustomLoadingButton>
                  </div>
                </ExpandableComponent>

                <div className="filtered-people-table">
                  {filteredPersonData?.length > 0 &&
                    <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                      <h1 className="sub-title" style={{ padding: "10px" }}>{t('found')} {filteredPersonData?.length} {filteredPersonData?.length > 1 ? t('people') : t('entity')}</h1>
                      {filteredPersonData?.length > rowsPerPage &&
                        <TablePagination
                          rowsPerPageOptions={[5]}
                          rowsPerPage={rowsPerPage}
                          onRowsPerPageChange={handlePersonRowsPerPage}
                          component="div"
                          count={filteredPersonData?.length}
                          rows={filteredPersonData}
                          page={entityPage}
                          onPageChange={handlePersonChangePage}
                        />}
                    </div>}
                  <div className="table-content">
                    <TableContainer component={Paper} className="table-container">
                      <Table sx={{ width: "max-content" }}>
                        {/* <TableHead className="tablehead">
                          <TableRow className="tablerow">
                            <TableCell className="table-cell center" style={{ maxWidth: "40px" }}>
                              #
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "120px" }}>
                              <span>{t('code').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ width: "auto", }}>
                              <span>{t('entity').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                              <span>{t('sector').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "170px" }}>
                              <span>{t('type').toUpperCase()}</span>
                            </TableCell>
                             <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                 <span>{t('status').toUpperCase()}</span>
                              </TableCell>
                          </TableRow>
                        </TableHead> */}
                        <TableBody className="tablebody">
                          {slicedPersonData?.map((row, index) => (
                            <TableRow
                              key={row?._id}
                              className={`${selectedPerson?._id === row?._id ? "tablerow current" : "tablerow"}`}
                              onClick={() => setSelectedPerson(row)}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "40px" }}>
                                <h1 className="sub-title" style={{ fontSize: "12px" }}>{entityPage * rowsPerPage + index + 1}</h1>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "120px" }}>
                                <h1 className="entity-code"
                                  onClick={(e) => {
                                    try {
                                      e.stopPropagation()
                                      setSelectedPerson(row);
                                      navigate(`/entity/${row?._id}`, { state: { person: "Y" } });
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}>{row?.ent_code}</h1>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto" }}>
                                <div style={{ display: "flex", width: "100%", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                                  {row?.ent_photo_url && <img
                                    src={row?.ent_photo_url}
                                    alt=""
                                    style={{ width: "40px", height: "40px", borderRadius: "8px" }}
                                  />}
                                  {!row?.ent_photo_url && <CiImageOn style={{ width: "40px", height: "40px" }} />}
                                  <div style={{ width: "100%", flexDirection: "column" }}>
                                    <h1 className="sub-title">{row?.ent_name}</h1>
                                    <h1 className="sub-title" style={{ fontSize: "12px" }}>{row?.ent_alias}</h1>
                                  </div>
                                </div>
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                <div style={{ width: "100%", flexDirection: "column" }}>
                                  <h1 className="sub-title soft" style={{ fontSize: "10px" }}>{t('sector')}</h1>
                                  <h1 className="sub-title" style={{ fontSize: "12px" }}>{row?.ent_sector_xx || `${t('sector')} ${t('unspecified')}`}</h1>
                                  <h1 className="sub-title" style={{ fontSize: "12px" }}>{row?.ent_sub_sector_xx || `${t('sub')} ${t('unspecified')}`}</h1>
                                </div>
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "170px" }}>
                                <div style={{ width: "100%", flexDirection: "column" }}>
                                  <h1 className="sub-title soft" style={{ fontSize: "10px" }}>{t('type')}</h1>
                                  <h1 className="sub-title" style={{ fontSize: "12px" }}>{row?.entity_type_xx}</h1>
                                  <h1 className="sub-title" style={{ fontSize: "12px" }}>{row?.aent_name_xx}</h1>
                                </div>
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "170px" }}>
                                <div style={{ width: "100%", flexDirection: "column" }}>
                                  <h1 className="sub-title soft" style={{ fontSize: "10px" }}>{t('created')}</h1>
                                  <h1 className="sub-title" style={{ fontSize: "14px" }}>{t('clientSince')}</h1>
                                  <h1 className="sub-title" style={{ fontSize: "12px" }}>{row?.created_xx}</h1>
                                </div>
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "120px" }}>
                                <span className={`status ${getCssValue(row?.ent_status)}`}>{row?.ent_status}</span>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </motion.div>}
          </motion.div>
        </div>
      )}
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton ref={closeBtnRef} onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {isOverlayOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <span className="main-title">{t('creatingPeople').toUpperCase()}</span>
              <CircularButton currentTheme={currentTheme} onClick={() => setIsOverlayOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <VideoPlayer videoUrl="creatingClients" />
            </div>
            <div className="overlay-actions">
            </div>
          </div>
        </motion.div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={["people-listings"]}
                documentData={{
                  docNo: "people",
                  docType: "people",
                  docId: "people",
                  filters: {
                    ent_code: filterPerson ? filterPerson?.value : filterEntCode,
                    ent_status: !filterEntStatus || filterEntStatus?.value === "All" ? "" : filterEntStatus?.value,
                    ent_type: !filterEntType || filterEntType.value === "All" ? "" : filterEntType?.value,
                    ent_aent_code: !filterEntCategory || filterEntCategory?.value === "All" ? "" : filterEntCategory?.value,
                    ent_sector: !filterEntSector || filterEntSector?.value === "All" ? "" : filterEntSector?.value,
                    ent_sub_sector: !filterEntSubSector || filterEntSubSector?.value === "All" ? "" : filterEntSubSector?.value,
                  }
                }} />
            </div>
          </div>
        </motion.div>
      )}
    </motion.div >
  );
};

export default HrPeople;
